//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            // 图片路径
            imgUrl:'',
            item_list:[],
        }
    },
    activated(){
        // 获取图片路径
        this.imgUrl =  sessionStorage.getItem('ossPath')
        this.getData()
    },
    methods:{
        // 获取数据
        async getData(){
            let sid = sessionStorage.getItem('sid')
            let data = {
                stauts: '',
                sid: sid
            }
            let res = await this.$HTTP.HttpPost('/member/Appointment/getOrderList',data)
            this.item_list = res.data.data.data
            this.item_list.forEach(item => {
                let time = item.appoint_day * 1000
                let date = new Date(time)
                var YY = date.getFullYear() + '-';
                var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                item.time = MM + DD + ' ' + item.appoint_times 
                item.Time = YY + MM + DD + ' ' + item.appoint_times

                item.picture = this.imgUrl + item.picture
            })
            console.log(this.item_list);
        },
        // 详情
        toDetails(i){
            this.$router.push({
                name:'/yuyuedetails',
                params:{
                    info:i
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/wodeyuyue.vue